import { Injectable } from '@angular/core';
import { WeissmanModalService } from '../../../../Compliance/WeissmanModalService';
import { ParcelActivityComponent } from './parcelActivity.component';

@Injectable({ providedIn: 'root' })
export class ParcelActivityModalService {
    constructor(private readonly _weissmanModalService: WeissmanModalService) {}

    async open(parcelID: number, siteID: number, years: number[]): Promise<void> {
        const params = {
            parcelId: parcelID,
            siteId: siteID,
            years: years
        }
        await this._weissmanModalService.showAsync(ParcelActivityComponent, params, 'modal-lg');
    };
}
